import StreetParkingBills from 'feature/street-parking/street-parking-bills/street-parking-bills';

export default StreetParkingBills;
